import type { AccesoDeInicio } from '../api/operaciones';
import { dibujoDe } from '../marco/iconosMenu';
import { Icono } from './Icono';

/**
 * «Tus accesos» de Inicio (G129; captura 0.1): fila de hasta seis baldosas blancas con su icono en negro (el principal,
 * `primary`, en rojo) y «Cambiar accesos». Es solo la pieza: la pantalla de Inicio llega con su módulo (Analítica) y la
 * coloca; los accesos salen de getMyNavigation (`accesosDeInicio`) y «Cambiar accesos» guarda `home_shortcuts` con
 * `updateMyNavigationPreferences`. La cifra de cada acceso del prototipo («Reservas de hoy 18») no está en el contrato
 * (`NavigationShortcut`): no se pinta. Uno de un bloque sin contratar (`not_contracted`, solo al Propietario, G963) lleva
 * «+» y el nombre en gris; `onIr` lo lleva a la entrada `plan`.
 */
export function TusAccesos({ accesos, onIr, onCambiar }: { accesos: readonly AccesoDeInicio[]; onIr: (a: AccesoDeInicio) => void; onCambiar: (() => void) | null }) {
    if (accesos.length === 0) {
        return null;
    }
    return (
        <section aria-labelledby="rv-tus-accesos" className="rv-accesos">
            <div className="rv-accesos__cab">
                <h2 id="rv-tus-accesos">Tus accesos</h2>
                {onCambiar !== null && (
                    <button type="button" className="rv-accesos__cambiar" onClick={onCambiar}>
                        <Icono nombre="pencil" />
                        <span>Cambiar accesos</span>
                    </button>
                )}
            </div>
            <div className="rv-accesos__rejilla">
                {accesos.map((a) => (
                    <button
                        key={a.key}
                        type="button"
                        className="rv-accesos__baldosa"
                        aria-label={a.not_contracted ? `${a.label}. No contratado: ver cómo activarlo` : undefined}
                        onClick={() => {
                            onIr(a);
                        }}
                    >
                        <span className="rv-accesos__icono" style={{ background: a.primary ? 'var(--rv-red)' : 'var(--rv-ink)' }}>
                            <Icono nombre={dibujoDe(a.icon)} />
                        </span>
                        <span className="rv-accesos__texto" style={a.not_contracted ? { color: 'var(--rv-fg-3)' } : undefined}>
                            {a.label}
                        </span>
                        {a.not_contracted && <i className="icon-plus rv-accesos__mas" aria-hidden="true" />}
                    </button>
                ))}
            </div>
        </section>
    );
}
